export default {
  computed: {
    maxFlvSv () {
      return Math.max(this.data.flv, this.data.sv_nett)
    },
    xValues () {
      return [...Array(101).keys()]
    },
    colors () {
      return [ '#068ffb', '#0ee396', '#feb018', '#ff4560', '#765dd0', '#06B2BB']
    },
    sharedChartOptions () {
      return {
        legendShow: false,
        yMax: 100,
        colors: this.colors
       }
    },
    nonMemberValues () {
      let { _$, labels, colors } = this
      return {
        primary: [
          { label: labels.nonMember.separationAmount, value: _$(this.calcSeparationAmount(), 0), color: colors[2] },
        ],
        secondary: [
          { label: labels.nonMember.fundedComponent, value: _$(this.calcFundedComponentSplit(), 0), color: colors[0] },
          { label: labels.nonMember.unfundedComponent, value: _$(this.calcUnfundedComponentSplit(), 0), color: colors[1] },
        ]
      }
    },
    nonMemberChartOptions () {
      return this._chartOptions({
        ...this.sharedChartOptions,
        id: 'graph_nonmember',
        stacked: true,
        yMax: this.maxFlvSv
      })
    },
  },
  methods: {    
    graphNonMember () {
      let { labels } = this
      let separationAmountSeries = { name: labels.nonMember.separationAmount, type: 'line', data: [] }
      let fundedSeries = { name: labels.nonMember.fundedComponent, type: 'area', data: [] }
      let unfundedSeries = { name: labels.nonMember.unfundedComponent, type: 'area', data: [] }

      this.xValues.forEach(percent => {
        let separationAmount = this.calcSeparationAmount(percent)
        let separationFactor = this.calcComponentSplitSeparationFactor(separationAmount)

        let fundedAmount = this.calcFundedComponentSplit(separationFactor)
        let unfundedAmount = this.calcUnfundedComponentSplit(separationAmount, fundedAmount)

        separationAmountSeries.data.push(separationAmount)
        fundedSeries.data.push(fundedAmount)
        unfundedSeries.data.push(unfundedAmount)
      })

      this.nonMemberSeries = [ fundedSeries, unfundedSeries, separationAmountSeries ]
    },
    calcComponentSplitSeparationFactor (separationAmount) {
      switch (this.data.super_type) {
        case 'dfrdb': return 0
        // case 'css': return this.calcSeparationFactorNett(separationAmount)
        default: return this.calcSeparationFactorGross(separationAmount)
      }
    },
    calcSeparationAmount (splitPercent) {
      if (splitPercent === undefined) splitPercent = this.splitPercent

      return Number((this.maxFlvSv * (splitPercent / 100)).toFixed(0))
    },
    calcSeparationFactorGross (separationAmount) {
      let superType = this.data.super_type
      if (separationAmount === undefined) separationAmount = this.calcSeparationAmount()
   
      switch (superType) {
        case 'css': return Math.floor(separationAmount / 100) / Math.floor(this.data.sv_gross / 100)
        case 'pss': return Math.floor(separationAmount / 100) / Math.floor(this.data.sv_gross / 100)
        case 'msbs': return this.splitAb ? separationAmount / (this.data.sv_gross - this.data.ab) : separationAmount / this.data.sv_gross
        case 'dfrdb': return separationAmount / this.data.sv_gross
      }
    },
    calcSeparationFactorNett (separationAmount) {
      if (separationAmount === undefined) separationAmount = this.calcSeparationAmount()
   
      return Math.floor(separationAmount / 100) / Math.floor(this.data.sv_nett / 100)
    },
    calcFundedComponentSplit (separationFactor) {
      if (this.data.super_type === 'dfrdb') return 0
      if (separationFactor === undefined) separationFactor = this.calcComponentSplitSeparationFactor()
      
      return Number((this.fundedComponent * separationFactor).toFixed(0))
    },
    calcUnfundedComponentSplit (separationAmount, fundedAmount) {
      if (separationAmount === undefined) separationAmount = this.calcSeparationAmount()
      if (fundedAmount === undefined) fundedAmount = this.calcFundedComponentSplit()

      return separationAmount - fundedAmount
    },
    calcBenefitReductionRate (sfGross) {
      if (sfGross === undefined) sfGross = this.calcSeparationFactorGross()
      let rate = sfGross * 100
      return Math.round((rate + Number.EPSILON) * 10000) / 10000
    },

  }
}